<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const FeatureBuyInIcon = getIcon("FeatureBuyInIcon");
</script>

{#if typeof FeatureBuyInIcon === 'string'}
	<img src={FeatureBuyInIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof FeatureBuyInIcon === 'function'}
	<svelte:component this={FeatureBuyInIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
